import moment from 'moment-timezone';

export function getTodayObject() {
  // Change timestamp from London To Berlin Time:
  const s = moment.tz(Date.now(), 'Europe/Berlin');
  return {year: s.get('year'), month: s.get('month') + 1, day: s.get('date')};
}

export function getDateObject(date) {
  // Change timestamp from London To Berlin Time:
  const s = moment.tz(date, 'Europe/Berlin');
  return {year: s.get('year'), month: s.get('month') + 1, day: s.get('date')};
}

export const dateTwoNumberFormat = (num) => (num > 9 ? num : `0${num}`);

export function fromObjectToDate(obj) {
  obj.month -= 1;
  return `${obj.year}-${dateTwoNumberFormat(
    obj.month + 1
  )}-${dateTwoNumberFormat(obj.day)}`;
}

export function getCurrentDate(date) {
  return moment(date).format('YYYY-MM-DD');
}

export function getDateOfLastDayInYear(date) {
  return moment(date).endOf('year').format('YYYY-MM-DD');
}

export function getDateAfterOneDay(date = new moment()) {
  return moment(date).add(1, 'day').format('YYYY-MM-DD');
}

export function getDateAfterOneYear(date = new moment()) {
  return moment(date).add(1, 'year').format('YYYY-MM-DD');
}

export function getDateAfterOneYearMinusOneDay(date = new moment()) {
  return moment(date).add(-1, 'day').add(1, 'year').format('YYYY-MM-DD');
}

export function diff(a, b) {}

export function dateFormat(date) {
  // @ts-ignore:
  return Number(moment(date).format('YYYYMMDD'));
}

export function getYear(t) {
  if (t === undefined || t === null || t === '') t = Date.now();
  return moment.tz(t, 'Europe/Berlin').format('YYYY');
}

export function switchTimeZone(t) {
  return moment.tz(t, 'Europe/Berlin').format('YYYY-MM-DD HH:mm');
}

export function switchTimeZoneYMD(t) {
  return moment.tz(t, 'Europe/Berlin').format('YYYY-MM-DD');
}

export function getYyyyMmDd(t) {
  if (t === undefined || t === null || t === '') return '-';
  // Change timestamp from London To Berlin Time:
  return moment.tz(t, 'Europe/Berlin').format('YYYY-MM-DD');
}

export function getYyyyMmDdNoTimeZone(t) {
  if (t === undefined || t === null || t === '') return '-';
  // Change timestamp from London To Berlin Time:
  // console.log(t,moment(t).format('YYYY-MM-DD'),moment.tz(t, 'Europe/Berlin').format('YYYY-MM-DD'))
  return moment(t).format('YYYY-MM-DD');
}

export function getHHmm(t) {
  if (t === undefined || t === null || t === '') return '-';
  // Change timestamp from London To Berlin Time:
  return moment.tz(t, 'Europe/Berlin').format('HH:mm');
}

export function matchYYYYMM(t) {
  return /([0-9]{4})-([0-9]{1,2})/.test(t);
}

export function matchYYYYMMDD(t) {
  return /([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})/.test(t);
}

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
